import React, { useState } from "react"
import { Grid, IconButton, InputLabel, MenuItem, Select, TextField, Typography, FormControl } from "@material-ui/core"
import { KeyboardArrowDown } from "@material-ui/icons"
import { useTranslation } from "react-i18next"
import MinusIconSvg from "../../icons/MinusIconSvg"
import PlusIconSvg from "../../icons/PlusIconSvg"

import useStyles from "./styles"

function AddUserRow({ data, handleAssignmentDetails, addRow, deleteRow }) {
	const { SkeletonList, formik, assignmentDetails, MenuProps, isUsersListLoading, usersList, userListItems, isAssigmentDone } = data

	const classes = useStyles()
	const [t] = useTranslation("global")
	//const [validate, setValidate] = useState({})

	return assignmentDetails?.userRow?.map((value, idx) => {
		let assignTo = `assignTo-${idx}`,
			percentageId = `percentage-${idx}`

		return (
			<Grid container key={value?.index} spacing={2} className={classes.marginBottom}>
				<Grid item xs={6}>
					<FormControl variant="filled" fullWidth>
						<InputLabel id={`${assignTo}-file-select-label`}>{t("review.reviewForm.assignTo")}</InputLabel>
						<Select
							labelId={`${assignTo}-file-select-label`}
							id={`${assignTo}-file-select`}
							name={`${assignTo}-file-select`}
							fullWidth
							MenuProps={MenuProps}
							className={`${classes.autoSelect} ${classes.formField}`}
							variant="outlined"
							onChange={(e) => handleAssignmentDetails(e, idx, value?.index, "select")}
							IconComponent={KeyboardArrowDown}
							value={value?.assignTo}
							renderValue={() => {
								const selectedUser = usersList?.find((user) => user.user_id === value?.assignTo)
								return selectedUser?.username
							}}
						>
							{isUsersListLoading ? (
								<SkeletonList />
							) : usersList.length ? (
								usersList
									?.filter(
										(user) =>
											!assignmentDetails?.userRow?.some((assignedUser) => assignedUser?.assignTo === user?.user_id)
									)
									?.map((user) => (
										<MenuItem key={user?.user_id} value={user?.user_id}>
											{user?.username}
										</MenuItem>
									))
							) : (
								<MenuItem value="">
									<em>{t("review.noDataFound")}</em>
								</MenuItem>
							)}
						</Select>
					</FormControl>
				</Grid>
				<Grid item xs={5} justifyContent="flex-end">
					<TextField
						id={percentageId}
						name={percentageId}
						type="number"
						label={t("review.reviewForm.percentageLabel")}
						variant="outlined"
						className={classes.formField}
						placeholder={t("review.reviewForm.percentageTitle")}
						onBlur={(e) => {
							handleAssignmentDetails(e, idx, value?.index, "text")
						}}
						error={Boolean(value?.percentageErr)}
						helperText={value?.percentageErrMsg}
						disabled={formik.values.file_equal_assignment}
						required={true}
					/>
				</Grid>
				<Grid item xs={1}>
					{idx === 0 ? (
						<IconButton
							style={{ paddingLeft: 0 }}
							onClick={() => addRow()}
							disabled={isAssigmentDone || Boolean(value?.percentageErr)}
						>
							<PlusIconSvg />
						</IconButton>
					) : (
						<IconButton style={{ paddingLeft: 0 }} onClick={() => deleteRow(idx)}>
							<MinusIconSvg />
						</IconButton>
					)}
				</Grid>
			</Grid>
		)
	})
}

export default AddUserRow
